// 公益sass
export const welfare_leaf = require("../assets/images/welfare/leaf.png");
export const carbon_titlebg = "https://resources-cn.miotech.com/static/mp2c/images/mp2c2.0/publicWelfare/carbon_titlebg.png";
export const huanbao_titlebg = "https://resources-cn.miotech.com/static/mp2c/images/mp2c2.0/publicWelfare/huanbao_titlebg.png";
export const humanity_titlebg = "https://resources-cn.miotech.com/static/mp2c/images/mp2c2.0/publicWelfare/humanity_titlebg.png";
export const carbon_history = "https://resources-cn.miotech.com/static/mp2c/images/mp2c2.0/publicWelfare/carbon_history.png"
export const huanbao_history = "https://resources-cn.miotech.com/static/mp2c/images/mp2c2.0/publicWelfare/huanbao_history.png"
export const humanity_history = "https://resources-cn.miotech.com/static/mp2c/images/mp2c2.0/publicWelfare/humanity_history.png"
export const welfare_introduce1 = require("../assets/images/welfare/welfare_introduce1.png");
export const welfare_introduce2 = require("../assets/images/welfare/welfare_introduce2.png");
export const welfare_introduce3 = require("../assets/images/welfare/welfare_introduce3.png");
export const welfare_rule1 = require("../assets/images/welfare/welfare_rule1.png");
export const welfare_rule2 = require("../assets/images/welfare/welfare_rule2.png");
export const welfare_rule3 = require("../assets/images/welfare/welfare_rule3.png");
export const certificate_title = require("../assets/images/welfare/certificate_title.png");
export const certificate_boby = require("../assets/images/welfare/certificate_boby.png");
export const certification_title_img = require("../assets/images/welfare/certification_title_img.png");
export const arrow_right = require("../assets/images/welfare/arrow_right.png");
export const walfare_participation_1 = require("../assets/images/welfare/walfare_participation_1.png");
export const walfare_participation_2 = require("../assets/images/welfare/walfare_participation_2.png");
export const walfare_participation_3 = require("../assets/images/welfare/walfare_participation_3.png");
export const walfare_guide_icon = require("../assets/images/welfare/guide_icon.png");
export const walfare_dot_icon = require("../assets/images/welfare/dot.png");
export const walfare_records_1 = require("../assets/images/welfare/walfare_records_1.png");
export const walfare_records_2 = require("../assets/images/welfare/walfare_records_2.png");
export const walfare_records_3 = require("../assets/images/welfare/walfare_records_3.png");
export const arrow_right_gray_icon = require("../assets/images/welfare/arrow_right_gray_icon.png");

/* 公益sass end */

/* 骑行 start */
export const map_icon_start = require("../assets/images/bikeRide/icon_start.png");
export const map_icon_end = require("../assets/images/bikeRide/icon_end.png");
export const map_icon_direction = require("../assets/images/bikeRide/icon_direction.png");
/* 骑行 end */

// 分享logo
export const app_logo = "https://miotech-mio.oss-cn-shanghai.aliyuncs.com/static/mp2c/images/mp2c2.0/assets/Icon-App-60x60%403x.png";

export const bill_rectangle_3078 = require("../assets/images/bill/bill_rectangle_3078.png");
export const bill_rectangle_3079 = require("../assets/images/bill/bill_rectangle_3079.png");
export const mio_copy_color_icon = require("../assets/images/bill/mio_copy_color_icon.png");
export const subtract = require("../assets/images/bill/subtract.png");
export const green_living_empty = require("../assets/images/bill/green_living_empty.png");
